import { shallowEqual, useSelector } from "react-redux";
import { ProductionSite } from '../productionSites/models/ProductionSitesModel';
import { useMsal } from "@azure/msal-react";

export const usePlant = (): string => {
  const { plantCode } = useSelector(
    (state: any) => (
      {
        plantCode: state.components.plantCode
      }),
    shallowEqual
  );
  const productionSites = useAccessibleProductionSites();
  if (plantCode !== '') {
    return plantCode;
  }
  if (productionSites.length > 0) {
    return productionSites[0].code;
  }
  return 'YPB';
};

export const useProductionSites = (): ProductionSite[] => {
  const { productionSites } = useSelector(
    (state: any) => ({ productionSites: state.productionSites.productionSites }),
    shallowEqual
  );
  return productionSites;
};

export const useCarrierConfigurationSupport = () => {
  const { plantSupportsCarrierConfiguration } = useSelector(
    (state: any) => ({ plantSupportsCarrierConfiguration: state.components.plantSupportsCarrierConfiguration }),
    shallowEqual
  );
  return plantSupportsCarrierConfiguration;
};

export const useAccessibleProductionSites = (): ProductionSite[] => {
  const { accounts }: any = useMsal();
  const productionSites = useProductionSites();

  var roles = accounts[0].idTokenClaims.roles ?? [];
  var accessibleProductionSites: ProductionSite[] = [];
  // find the plants available based on the roles of the user.
  roles.forEach((role: string) => {
    if (role === "Developer") {
      accessibleProductionSites = accessibleProductionSites.concat(productionSites);
    }
    else {
      const plantCode = extractPlantCodeFromRole(role);
      if (plantCode) {
        const productionSitesToAdd = productionSites.filter((x) => x.code === plantCode);
        accessibleProductionSites = accessibleProductionSites.concat(productionSitesToAdd);
      }
    }
  })
  const uniqueProductionSites = accessibleProductionSites.filter((value, index, self) => self.indexOf(value) === index)

  return uniqueProductionSites;

  function extractPlantCodeFromRole(role: string): string | null {
    const match = role.match(/([A-Z_]+)WriteAccess|([A-Z_]+)ReadAccess/);
    return match ? match[1] || match[2] : null;
  }
}